import { Injectable } from "@angular/core";
import { AnalyticsLogModel } from "@types";
import { Observable } from "rxjs";
import { ActivityService } from "./activity.service";
import { ApiService } from "./api.service";
import { AuthService } from "./auth.service";

export type LogModel = Omit<AnalyticsLogModel, "sessionId" | "userId">;

export function analyticsServiceInitializerFactory(_: AnalyticsService) {
  return () => {
    // Service will be instantiated as it's been injected, and it's
    // lifetime will be tied to the lifetime of the app as it's provided in root
  };
}

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private activityService: ActivityService
  ) {}

  public logEvent(event: LogModel): Observable<string> {
    return this.logEvents([event]);
  }

  public logEvents(events: LogModel[]): Observable<string> {
    const mappedEvents = this.enrichEvents(events);
    return this.apiService.post({
      path: "/api/v3/Analytics",
      body: mappedEvents,
    });
  }

  private enrichEvents(models: LogModel[]): AnalyticsLogModel[] {
    const userId = this.authService.getUserId();
    const sessionId =
      this.activityService.getSessionId() ??
      this.activityService.generateAndStoreSessionId();
    return models.map((m) => {
      return {
        ...m,
        sessionId,
        userId,
      };
    });
  }
}
